import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { authService } from "../services/authService";
import Logo from "./Logo";

export default function RegisterForm({ onBackToLogin }) {
  const [email, setEmail] = useState("");

  const registerMutation = useMutation({
    mutationFn: ({ email: em }) => authService.register({ email: em }),
    onSuccess: () => {
      toast.success("Solicitud enviada. Revisa tu correo para los siguientes pasos.");
      setEmail("");
      onBackToLogin();
    },
    onError: (err) => {
      toast.error(err?.message || "No se pudo enviar la solicitud");
    },
  });

  function onSubmit(e) {
    e.preventDefault();
    if (!email) {
      toast.error("Introduce tu email");
      return;
    }
    registerMutation.mutate({ email });
  }

  return (
    <div className="zx-card zx-card-static zx-glass h-full space-y-8 p-7 md:p-8" data-testid="register-form">
      <header className="flex flex-col items-center gap-4 text-center">
        <Logo size={100} />
        <div className="space-y-2">
          <p className="text-sm text-[rgba(255,255,255,0.65)]">
            Estás a un paso de descubir La Lista.
          </p>
        </div>
      </header>

      <form onSubmit={onSubmit} className="space-y-5">
        <div className="space-y-1">
          <label className="zx-label" htmlFor="r-email">
            Email
          </label>
          <input
            id="r-email"
            type="email"
            autoComplete="email"
            className="zx-input"
            placeholder="tu@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email-input"
          />
        </div>

        <button
          type="submit"
          className="zx-btn-primary"
          disabled={registerMutation.isPending}
          data-testid="register-submit-button"
        >
          {registerMutation.isPending ? "Pidiendo..." : "Pide acceso"}
        </button>
      </form>

      <div className="text-center text-sm text-[rgba(255,255,255,0.65)]">
        ¿Ya tengo acceso?{" "}
        <button
          type="button"
          className="text-[#e9b5c5] underline decoration-[rgba(184,50,90,0.5)] underline-offset-4 hover:text-[#f5f5f5]"
          onClick={onBackToLogin}
          data-testid="register-login-toggle"
          aria-label="Voltear tarjeta al formulario de inicio de sesión"
        >
          Entrar
        </button>
      </div>
    </div>
  );
}
